<template>
	<BaseCard :is-editable="false" :title="$t('case_information').toString()" :is-toggleable="false">
		<BaseCardRow :value="imdNet" label="IMD-NET" />

		<div class="grid grid-cols-2 items-center break-words leading-none mb-2 max-w-full w-full">
			<div class="font-bold">{{ $t('damage_assessor_file_number') }}:</div>

			<div class="flex items-center justify-between">
				<div>
					{{ referenceNumber }}
				</div>

				<div class="progress-action-slot">
					<button
						v-if="isEditable"
						type="button"
						@click="$emit('editReferenceNumber')"
						class="bg-sp btn block btn-overview-edit progress-action-btn flex items-center justify-center text-white"
					>
						<font-awesome-icon :icon="['fas', 'edit']" />
					</button>
				</div>
			</div>
		</div>
		<template v-if="brokerCase">
			<BaseCardRow :value="brokerName" :label="$t('broker')" class="mt-6" />
			<BaseCardRow :value="brokerStatus" :label="$t('broker_case_status')" />
		</template>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';

import { getBrokerCaseStatus } from '@/helpers/Utils';
import { concatArray } from '@/plugins/Utils';

export default {
	name: 'DamageAssessorCaseInformationCard',

	components: {
		BaseCard,
		BaseCardRow,
	},

	props: {
		damageAssessorCase: {
			type: Object,
			required: true,
		},

		isEditable: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		brokerCase() {
			return this.damageAssessorCase?.broker_case ?? null;
		},
		imdNet() {
			return this.damageAssessorCase?.imd_net ?? '-';
		},
		referenceNumber() {
			return this.damageAssessorCase?.reference_number ?? '-';
		},
		brokerName() {
			const broker = this.brokerCase?.insurance_broker;

			if (!broker) {
				return '-';
			}

			return concatArray([broker.ownerFirstname, broker.ownerLastname]) || '-';
		},
		brokerStatus() {
			if (!this.brokerCase?.status) {
				return '-';
			}

			return getBrokerCaseStatus(this.brokerCase.status);
		},
	},
};
</script>

<style scoped></style>
